"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scale_1 = require("@antv/scale");
exports.Scale = scale_1.Scale;
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/attr/lib/interface.js
// module id = 580
// module chunks = 37